export default () => ({
  select: {
    width: '100%',
    '& .MuiInputLabel-root': {
      maxWidth: 'calc(100% - 40px)',
    },
  },
});
